"use client";
import { jsxs as e, jsx as a } from "react/jsx-runtime";
const o = ({
  title: r,
  titleId: t,
  desc: l,
  descId: i,
  ...n
}) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "-.5 -.5 16 16",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": t,
    "aria-describedby": i,
    ...n,
    children: [
      r ? /* @__PURE__ */ a("title", { id: t, children: r }) : null,
      l === void 0 ? /* @__PURE__ */ a("desc", { id: i, children: `
    Graduation Cap Light Streamline Icon: https://streamlinehq.com
  ` }) : l ? /* @__PURE__ */ a("desc", { id: i, children: l }) : null,
      /* @__PURE__ */ a("path", { d: "M14.6651 4.858 7.6645 1.1241a.347.347 0 0 0-.329 0L.3349 4.858c-.2376.1272-.2484.4638-.0195.606a.4.4 0 0 0 .0195.0112l1.6813.8973V9.267c0 .2005.0736.394.207.5437.7509.836 2.4351 2.2397 5.2768 2.2397a7.42 7.42 0 0 0 2.917-.5677v2.0845c.0003.2694.2922.4375.5254.3024a.35.35 0 0 0 .1746-.3024v-2.4298a6.6 6.6 0 0 0 1.6597-1.3272.812.812 0 0 0 .2071-.5432V6.3724l1.6813-.8973c.2376-.1271.2484-.4638.0195-.606a.4.4 0 0 0-.0195-.0112M7.5 11.3503c-2.5669 0-4.0837-1.2578-4.7558-2.0074a.117.117 0 0 1-.028-.0759V6.7457l4.6193 2.4631a.35.35 0 0 0 .329 0L10.417 7.741v2.9753c-.7584.3628-1.7239.6341-2.9169.6341m4.7838-2.0833c0 .0278-.01.0547-.028.0759-.3362.3724-.719.7-1.1388.9748V7.3676l1.1668-.6219ZM10.9916 6.642a.37.37 0 0 0-.0584-.0414l-3.267-1.742c-.2428-.1167-.521.0734-.5005.342a.35.35 0 0 0 .1715.2752l2.9193 1.5577L7.5 8.5034 1.2432 5.1666 7.5 1.8295l6.2568 3.337Z" })
    ]
  }
);
export {
  o as default
};
